// extracted by mini-css-extract-plugin
export var video = "Video-module--video--2ee51";
export var videoProperties = "Video-module--video-properties--91b60";